export enum ShedBaseSkidDirection {
  GableToGable = 'gable-to-gable',
  SideToSide = 'side-to-side',
}
